import React, { Component } from "react";
import { NavLink, withRouter, Link } from "react-router-dom";
import Button from "@material-ui/core/Button";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";

import Axios from "../../actions/Axios";
import { API_GET_CHAT_NOTIFICATIONS } from "../../ApiUrl";
class SidenavContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
    };
  }
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `#${history.location.pathname}`; // get current path

    const subMenuLi = document.querySelectorAll(".sub-menu > li");
    for (let i = 0; i < subMenuLi.length; i++) {
      subMenuLi[i].onclick = function(event) {
        event.stopPropagation();
      };
    }

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function(event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
        event.stopPropagation();
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
    this.getTableRecords();
    setInterval(() => {
      this.getTableRecords();
    }, 10000);
  }
  getTableRecords = async () => {
    this.setState({ loading: true });

    Axios.post(API_GET_CHAT_NOTIFICATIONS, {
      companyId: localStorage.getItem("_id"),
      readStatus: "false",
    })
      .then((response) => {
        const { status, data, totalCount } = response.data;
        console.log(response, "i m m m ");
        if (status === 1) {
          this.setState({
            count: totalCount,
          });
        }
      })
      .catch((err) => {});
  };

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function(fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  }

  render() {
    const { count } = this.state;

    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="menu no-arrow">
            <Link to="/app/dashboard/index">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </Link>
          </li>

          <li className="menu no-arrow">
            <Link to="/app/dumpsters">
              <i className="zmdi zmdi-delete zmdi-hc-fw" />
              <span className="nav-text">Orders</span>
            </Link>
          </li>
          <li className="menu no-arrow">
            <NavLink to="/app/notifications">
              <i className="zmdi zmdi-notifications zmdi-hc-fw" />
              <span className="nav-text">
                Notifications <span id="notification">{count}</span>
              </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <Link to="/app/drivers">
              <i className="zmdi zmdi-car-wash zmdi-hc-fw" />
              <span className="nav-text">Drivers</span>
            </Link>
          </li>

          <li className="menu no-arrow">
            <Link to="/app/settings">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Settings</span>
            </Link>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);
